import { API_URL } from './apiUrl';

let sessionId = sessionStorage.getItem('te_sid');
if (!sessionId) {
  sessionId = Math.random().toString(36).substring(2) + Date.now().toString(36);
  sessionStorage.setItem('te_sid', sessionId);
}

const pendingEvents = [];
let flushTimer = null;

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = setTimeout(flushEvents, 2000);
}

async function flushEvents() {
  flushTimer = null;
  if (pendingEvents.length === 0) return;
  const batch = pendingEvents.splice(0, pendingEvents.length);
  try {
    await fetch(`${API_URL}/api/analytics/track-batch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(batch),
    });
  } catch (e) {
    // silent fail - analytics should never break UX
  }
}

export function trackEvent(eventType, data = {}) {
  pendingEvents.push({
    event_type: eventType,
    product_id: data.productId || null,
    seller_id: data.sellerId || null,
    slot_number: data.slotNumber || null,
    session_id: sessionId,
  });
  scheduleFlush();
}

export function trackPageView(eventType, data = {}) {
  trackEvent(eventType, data);
}

export function trackSlotImpressions(products) {
  if (!products || !products.length) return;
  for (const p of products) {
    trackEvent('slot_impression', {
      productId: p.id,
      sellerId: p.seller_id || null,
      slotNumber: p.homepage_slot,
    });
  }
}

export function trackProductClick(product, slotNumber) {
  trackEvent(slotNumber ? 'slot_click' : 'product_click', {
    productId: product.id,
    sellerId: product.seller_id || null,
    slotNumber: slotNumber || null,
  });
}

// Flush on page unload
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => {
    if (pendingEvents.length > 0) {
      const batch = pendingEvents.splice(0, pendingEvents.length);
      navigator.sendBeacon(
        `${API_URL}/api/analytics/track-batch`,
        JSON.stringify(batch)
      );
    }
  });
}
